import { PROFILE_TYPE_CLIENT, PROFILE_TYPE_FREE_PROFESSIONAL, PROFILE_TYPE_NORMAL_PROFESSIONAL, } from '@/utils/constants/profile/profileType';
/** コンサルタントのプロフィール型判定（通常orフリー） */
export const professionalProfile = (profile) => {
    const isProfessionalProfile = (profile === null || profile === void 0 ? void 0 : profile.profileType) === PROFILE_TYPE_NORMAL_PROFESSIONAL ||
        (profile === null || profile === void 0 ? void 0 : profile.profileType) === PROFILE_TYPE_FREE_PROFESSIONAL;
    if (isProfessionalProfile) {
        return profile;
    }
    return null;
};
/** クライアントのプロフィール型判定 */
export const isClientProfile = (profile) => (profile === null || profile === void 0 ? void 0 : profile.profileType) === PROFILE_TYPE_CLIENT;
